export default __webpack_public_path__ + "static/media/user.d6c1b476.svg";